import { Select } from 'antd';
import VehicleApi from '../../functions/api/vehicle/VehicleApi';
import React, { useEffect, useState } from 'react';
import { filterOption, normalizeOptions } from '../booking/form/CustomSelect';

interface Props {
  vehicleType: number;
  onChange: any;
  value: number;
}
export default function VerhicleNameSearch(props: Props) {
  const [vehicles, setVehicle] = useState([]);

  useEffect(() => {
    loadVehicle();
  }, [props.vehicleType]);

  async function loadVehicle() {
    const vehicles = await VehicleApi.getVehicleByTypeId(props.vehicleType);
    for (var i in vehicles) {
      vehicles[i]['vhc_full_name'] = `${vehicles[i]['vhc_bran_name']} 
        ${vehicles[i]['vhc_modl_name'] ? vehicles[i]['vhc_modl_name'] : ''}
        ${vehicles[i]['vhc_name']}`;
    }
    setVehicle(vehicles);
  }

  return (
    <Select
      value={props.value}
      showSearch
      filterOption={filterOption}
      options={normalizeOptions('vhc_full_name', 'vhc_id', vehicles)}
    />
  );
}
